import { Box, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { GrantedSourceGroup } from "./granted-source-group"
import { LEVEL_HEADINGS } from "./group-by-source"

/**
 * Client or User, as a section rather than a label on every row — where a demand is granted is
 * the first thing you need in order to change it, so it earns structure.
 *
 * The heading is suppressed when there is only one level present: on the client Access tab
 * every source is client-level, and a lone "Client" heading is noise.
 */
export function GrantedLevelSection({ item: section, showHeading }) {
    return (
        <Box data-cy={`access-level-${section.level}`}>
            <If value={showHeading}>
                <Typography variant="overline" color="text.secondary">
                    {LEVEL_HEADINGS[section.level] ?? section.level}
                </Typography>
            </If>
            <Stack spacing={1}>
                <Repeat list={section.groups} item={<GrantedSourceGroup />} keyFn={keyOf} />
            </Stack>
        </Box>
    )

    function keyOf(group) {
        return `${group.source}:${group.sourceId}`
    }
}
